export default __webpack_public_path__ + "static/media/decor-3.f97dad20.svg";